export default __webpack_public_path__ + "static/media/passUp.e9c87c21.svg";